import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-questionarios',
  templateUrl: './edit-questionarios.component.html',
  styleUrls: ['./edit-questionarios.component.scss']
})
export class EditQuestionariosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
